import { render, staticRenderFns } from "./TradeDetails.vue?vue&type=template&id=71250609&"
import script from "./TradeDetails.vue?vue&type=script&lang=js&"
export * from "./TradeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports